/**
 * useProfile
 *
 * 사용자 프로필을 조회합니다.
 */

import { useMany, useOne } from '@popow/infra/lib/supabase/query';
import type { Tables } from '@popow/infra/types/database.types';
import { parseUserProfileRow, parseUserProfileWithTikTokRow } from '../schema';

type UserProfileRow = Tables<'user_profiles'>;

/**
 * 사용자 기본 프로필을 조회합니다.
 */
export function useProfile(userId: string | null | undefined) {
  return useOne({
    tableName: 'user_profiles',
    key: ['user', 'profile', userId],
    enabled: !!userId,
    trailingQuery: query => query.eq('id', userId ?? '').single(),
    parseFn: (row: UserProfileRow) => parseUserProfileRow(row),
  });
}

/**
 * TikTok 정보가 포함된 사용자 프로필을 조회합니다.
 */
export function useProfileWithTikTok(userId: string | null | undefined) {
  return useOne({
    tableName: 'user_profiles',
    key: ['user', 'profile', 'withTikTok', userId],
    enabled: !!userId,
    trailingQuery: query => query.eq('id', userId ?? '').single(),
    parseFn: (row: UserProfileRow) => parseUserProfileWithTikTokRow(row),
  });
}

export function useProfiles() {
  return useMany({
    tableName: 'user_profiles',
    key: ['user', 'profiles'],
    parseFn: (row: UserProfileRow) => parseUserProfileRow(row),
  });
}
